import { browser } from '$app/environment';

export const getLocalStorage = (key: string) => {
  if (browser) {
    return window.localStorage.getItem(key);
  }
  return null;
};

export const getLocalStorageJson = (key: string) => {
  return JSON.parse(getLocalStorage(key) || 'null');
};

export const setLocalStorage = (key: string, value: string) => {
  if (browser) {
    window.localStorage.setItem(key, value);
  }
};

export const setLocalStorageJson = (key: string, value: unknown) => {
  setLocalStorage(key, JSON.stringify(value));
};

export const removeLocalStorage = (key: string) => {
  if (browser) {
    window.localStorage.removeItem(key);
  }
};
